﻿import { version } from "moment";

(function () {
    'use strict';

    var controllerId = 'serviceTime';

    angular.module('app.controllers').controller(controllerId, serviceTime)

    serviceTime.$inject = ['common', 'datacontext', '$http', '$scope', '$stateParams', '$translate'];

    function serviceTime(common, datacontext, $http, $scope, $stateParams, $translate) {
        let vm = this;

        vm.validFamilies = ['DRY', 'REF'];
        vm.validMovementsGTI = ['CD', 'DD', 'PD'];
        vm.validMovementsGTO = ['DC', 'DD', 'DP'];
        function init() {
            common.activateController().then(function (data) { });
            vm.initializeData();
            vm.clearCriteria();
            vm.getGeneralFilters().then(function () {
                vm.getOperationTypes().then(function () {
                    vm.clearReport();
                });
            });
        }

        vm.initializeData = function () {
            vm.listDepots = [];
            vm.listFamilies = [];
            vm.listMovementTypesGTI = [];
            vm.listMovementTypesGTO = [];
            vm.listMovementTypes = [];
            vm.listOperationTypes = [];
            vm.gridDataSource = new kendo.data.DataSource({
                data: []
            });

            vm.gridOptions = {
                dataSource: vm.gridDataSource,
                sortable: false,
                pageable: false,
                groupable: false,
                height: "10em",
                columns: [
                    {
                        title: $translate.instant('views.serviceTime.attentionTime'),
                        field: "SubProcess",
                        width: "35%",
                        attributes: {
                            "style": " text-align: center; font-weight: bold !important;",
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTime.gateIn'),
                        field: "GateIn",
                        width: "16%",
                        headerTemplate:kendo.template($("#GateInTemplate").html()),
                        attributes: {
                            "style": " text-align: center;"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTime.dispatch'),
                        field: "Dispatch",
                        width: "16%",
                        headerTemplate:kendo.template($("#DispatchTemplate").html()),
                        attributes: {
                            "style": " text-align: center;"
                        },
                        
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTime.preInspection'),
                        field: "PreInspection",
                        width: "16%",
                        headerTemplate:kendo.template($("#PreInspectionTemplate").html()),
                        attributes: {
                            "style": " text-align: center;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTime.inspection'),
                        field: "Inspection",
                        width: "16%",
                        headerTemplate:kendo.template($("#InspectionTemplate").html()),
                        attributes: {
                            "style": " text-align: center;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTime.gateOut'),
                        field: "GateOut",
                        width: "16%",
                        headerTemplate:kendo.template($("#GateOutTemplate").html()),
                        attributes: {
                            "style": " text-align: center;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    },
                    {
                        title: $translate.instant('views.serviceTime.total'),
                        field: "Total",
                        width: "16%",
                        headerTemplate:kendo.template($("#TotalTemplate").html()),
                        attributes: {
                            "style": " text-align: center;"
                        },
                        headerAttributes: {
                            "style": "text-align:center;"
                        }
                    }
                ]
            };
        }


        vm.getGeneralFilters = function () {
            var authData = common.localStorageService.get('authorizationData');

            return datacontext.servicetime.getFilters(vm.roleSelected).then(function (data) {
                if (data) {
                    if (data.Depot != null && data.Depot.length > 0) {
                        vm.listDepots = data.Depot;
                        vm.criteria.yardId = vm.listDepots[0].Id;
                        if (authData) {
                            var currentYardId = authData.ModelRequester.CurrentYardId;
                            if (currentYardId !== undefined)
                                vm.criteria.yardId = Number(currentYardId);
                        }
                    }

                    if (data.MovementType != null && data.MovementType.length > 0) {
                        angular.forEach(data.MovementType, function (movementType, key) {
                            if (vm.validMovementsGTO.indexOf(movementType.Code) != -1) {
                                vm.listMovementTypesGTO.push({ id: movementType.Id, label: movementType.Name, code: movementType.Code});
                            }

                            if (vm.validMovementsGTI.indexOf(movementType.Code) != -1) {
                                vm.listMovementTypesGTI.push({ id: movementType.Id, label: movementType.Name, code: movementType.Code});
                            }
                        });
                    }

                    vm.ServiceTimeUnitTime = data.ServiceTimeUnitTime;
                    var TextBefore = angular.element("#mainReport thead [data-field=SubProcess] ").html();
                    angular.element("#mainReport thead [data-field=SubProcess] ").html(TextBefore + " (" +vm.ServiceTimeUnitTime + ")");

                    if (data.FamilyList != null && data.FamilyList.length > 0) {
                        angular.forEach(data.FamilyList, function (family, key) {
                            if (vm.validFamilies.indexOf(family.Code) != -1) {
                                vm.listFamilies.push({ id: family.Id, label: family.Name });
                                vm.criteria.familyIds.push({id: family.Id});
                            }
                        });
                    }
                    vm.selectOperationType();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };

        vm.getOperationTypes = function () {
            return datacontext.servicetime.getOperationTypes().then(function (data) {
                if (data.Result == 1) {
                    angular.forEach(data.ActivityTypes, function (value, key) {
                        vm.listOperationTypes.push(value);
                    });
                }
                vm.criteria.operationTypeId =vm.listOperationTypes[0].EquipmentActivityTypeId;
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        }

        vm.selectOperationType = function () {
            // $("#ms_Family").hide();
            // $("#ddl_Family").hide();
            // vm.criteria.familyId = null;
            
            vm.criteria.movementTypeIds = [];
            vm.gridDataSource = { data: [] };
            vm.changeColumns();
             if (vm.getCurrentOperationTypeCode() === "GTI"){
              
                 vm.listMovementTypes = angular.copy(vm.listMovementTypesGTI); 
                 angular.forEach(vm.listMovementTypes, function (movement, key){
                     vm.criteria.movementTypeIds.push(movement);
                     //vm.criteria.movementTypeIds.push({ id: movement.Id });
                 });
             }
             else if (vm.getCurrentOperationTypeCode() === "GTO"){
            
                 vm.listMovementTypes = angular.copy(vm.listMovementTypesGTO);
                 angular.forEach(vm.listMovementTypes, function (movement, key) {
                     vm.criteria.movementTypeIds.push(movement);
                     //vm.criteria.movementTypeIds.push({ id: movement.Id });
                 });
             }else{
              
                 vm.listMovementTypes = angular.copy(vm.listMovementTypesGTI);
             }
            // $("#ms_Family").show();
   
        }

        vm.getCurrentOperationTypeCode = function () {
            var currentOperation = $(vm.listOperationTypes).filter(function (a, b) { return b.EquipmentActivityTypeId == vm.criteria.operationTypeId });
            if (currentOperation.length > 0) {
                    return currentOperation[0].Code;
            }else{
                    return null;
            }
        }

        vm.getObectsFromMultiSelectList = function (defaultItems) {
            var selectedObjects = [];
            angular.forEach(defaultItems, function (val, key) {
                angular.forEach(vm.listMovementTypes, function (movement, key) {
                    if (val == movement.code) selectedObjects.push(movement);
                });
            });
            return selectedObjects;
        }

        vm.clearCriteria = function () {
            vm.criteria = {
                yardId: vm.listDepots ? (vm.listDepots.length > 0 ? vm.listDepots[0].Id : 0) : 0,
                operationTypeId: vm.listOperationTypes ? (vm.listOperationTypes.length > 0 ? vm.listOperationTypes[0].EquipmentActivityTypeId : 0) : 0,
                // familyId:null,
                familyIds: [],
                movementTypeIds: [],
            };

            angular.forEach(vm.listFamilies, function (family, key) {
                vm.criteria.familyIds.push(family);
            });

            vm.refresReport();
        }

        vm.changeColumns = function (){
            var mainReport = angular.element('#mainReport').data("kendo-grid");
            if (mainReport && vm.getCurrentOperationTypeCode() === "GTI") {
                mainReport.hideColumn("Dispatch");
                mainReport.showColumn("PreInspection");
                mainReport.showColumn("Inspection");
            }

            else if (mainReport && vm.getCurrentOperationTypeCode() === "GTO") {
                mainReport.showColumn("Dispatch");
                mainReport.hideColumn("PreInspection");
                mainReport.hideColumn("Inspection");
            }
        }

        vm.clearReport = function () {
            vm.gridDataSource = { data: [] };
            vm.clearCriteria();
            vm.selectOperationType();
            vm.changeColumns();
        };

        vm.searchReport = function () {
            var valid = true;

            if (vm.criteria.familyIds.length == 0) {
                toastr.info($translate.instant('views.serviceTime.familyRequired'));
                valid = false;
            }

            if (vm.criteria.movementTypeIds.length == 0) {
                toastr.info($translate.instant('views.serviceTime.movementRequired'));
                valid = false;
            }

            // if (vm.getCurrentOperationTypeCode() === "GTO"){
            //     var movementTypeRestricted = 0;
            //      angular.forEach(vm.criteria.movementTypeIds, function (val, key) { 
            //         var currentMovementType = $(vm.listMovementTypesGTO).filter(function (a, b) { return b.id == val.id });
            //         if(currentMovementType[0].code != "DD"){
            //             movementTypeRestricted ++;
            //         }
            //     });

            //     if(movementTypeRestricted == 2){
            //         toastr.info($translate.instant('views.serviceTime.movementTypeInvalid_DC_DP'));
            //         valid = false;
            //     }
            // }

            if (!valid){
                return;
            }

            // if(vm.getCurrentOperationTypeCode() === "GTO" && vm.criteria.familyId != null){
            //     vm.criteria.familyIds = [];
            //     vm.criteria.familyIds.push({id:vm.criteria.familyId});
            // }

            var criteria = {
                YardId: vm.criteria.yardId,
                OperationTypeId: vm.criteria.operationTypeId,
                FamilyIdList: vm.GetIdsFromMultiSelectList(vm.criteria.familyIds).join(","),
                MovementTypeIdList: vm.GetIdsFromMultiSelectList(vm.criteria.movementTypeIds).join(",")
            };

            datacontext.servicetime.getServiceTimeList(criteria).then(function (data) {
                if (data) {
                    data[0].SubProcess = $translate.instant('views.serviceTime.truckQty');
                    data[1].SubProcess = $translate.instant('views.serviceTime.realTime');
                    data[2].SubProcess = $translate.instant('views.serviceTime.standardTime');
                    vm.gridDataSource = { data:data };
                    vm.refresReport();
                }
                else {
                    vm.clearReport();
                }
            }, function (err) {
                if (err.status)
                    toastr.error(err.info);
            });
        };


        vm.GetIdsFromMultiSelectList = function (selectedItems) {
            var ids = [];
            angular.forEach(selectedItems, function (val, key) { ids.push(val.id); });
            return ids;
        }

        vm.refresReport = function () {
            var mainReport = angular.element('#mainReport').data("kendo-grid");
            if (mainReport) {
                mainReport.refresh();
            }
        }

        init();

    }

})();
